import React from 'react'
import {Button, Header, Input, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import {createUserLog} from "../../lib/api";
import {useSelector} from "react-redux";

const PCSMacro =({title, description, option,data, tagid, display, channel}) => {

    const [toggle, setToggle] = React.useState();
    const [open,setOpen]= React.useState(false);
    const [tagdata, settagdata]= React.useState('');
    const [dataCopy, setDataCopy] = React.useState();
    const [isCopied, setIsCopied] = React.useState(false);
    const ppid = useSelector(state => state.header.ppid);
    const user = useSelector(state => state.nav.user);
    const electronApp = useSelector(state => state.nav.electronApp);

    React.useEffect(() => {
        if(typeof data !== 'undefined' && !isCopied){
            setDataCopy({...data});
            setIsCopied(true)
        }
    }, [data]);

    const handleOpen = () => setOpen( true);
    const handleClose = () => setOpen( false);

    const handleToggle =(event, {id}) => {
        setToggle(id);
        event.preventDefault();
        if (option === 1) {
                var pcsdata = {'buttonClickType': channel};
                socket.emit('button click', pcsdata);
                setOpen(false);
                if (!electronApp) {
                    let log = {
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: null,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ type: channel }),
                    };
                    createUserLog({ log }).catch(console.error);
                }
            }
        else {
            var writedata = [{'tag_id':tagid, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen(false);
        }
    }

    const handleCheck = (event, obj_key) => {
        if( event.target.id === "1") {
            settagdata(1);
            setDataCopy({...dataCopy, [tagid]: 1});
        }
        else if( event.target.id === "0"){
            settagdata(0);
            setDataCopy({...dataCopy, [tagid]: 0});
        }
    }

    
    return (
        <>
            {option === 2 ? // option 2 : checkoutMode 
                <>
                    <Modal trigger={<Button color={data === 1 ? 'green' : 'yellow'}>{title} </Button>}
                           style={styles.toggle}
                           open={open}
                           onClose={handleClose}
                           onOpen={handleOpen}>
                    <Modal.Header>Select Choice for {title} </Modal.Header>
                    <Modal.Content>
                        <Input
                            type='radio'
                            id={1}
                            label='ENABLE'
                            checked={typeof dataCopy !== 'undefined' ? dataCopy[tagid]  === 1 : ''}
                            onChange={(event, value) => handleCheck(event,tagid)}
                            style={styles.checkbox1}
                        />
                        <Input
                            type='radio'
                            id={0}
                            label='DISABLE'
                            checked={typeof dataCopy !== 'undefined' ? dataCopy[tagid]  === 0 : ''}
                            onChange={(event, value) => handleCheck(event,tagid)}
                            style={styles.checkbox1}
                        />
                    </Modal.Content>
                    <Modal.Actions style={styles.toggle}>
                        <Button color='blue' content={'Ok'}
                                onClick={(event, value) => handleToggle(event,tagid)}/>
                        <Button color='red' content={'Cancel'}
                                onClick={handleClose}/>
                    </Modal.Actions>
                </Modal>
                </>
                : // reset faults, pcs shutdown
                <Modal trigger={<Button color='blue'>{title} </Button>}
                       style={styles.toggle}
                       open={open}
                       onClose={handleClose}
                       onOpen={handleOpen}>
                    <Modal.Header>{title}</Modal.Header>
                    <Modal.Description>
                        <Header style={styles.header}> {description}</Header>
                    </Modal.Description>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id='1'
                                active={toggle === '1'}
                                content='OK'
                                onClick={handleToggle}
                        />
                        <Button color={'red'}
                                size='small'
                                id='2'
                                active={toggle === '2'}
                                content='Cancel'
                                onClick={handleClose}
                        />
                    </Modal.Actions>
                </Modal>
            }
            </>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    toggle: {
        maxWidth: '400px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '15px'
    },
    checkbox1: {
        flexDirection: 'row-reverse',
        marginLeft: '5px',
    }
}

export default PCSMacro;
